export const ANALYTICS_EVENTS = {
    CONTACT_FORM_SENT: 'Contact Form Sent',
    CONTACT_CTA_ON_MOBILE: 'Contact CTA on Mobile',
    COOKIE_CONSENT: 'Cookie Consent',
    CONTACT_NO_WHATSAPP: 'Contact No WhatsApp',
    LEAD_MAGNET_CLICK: 'Lead Magnet Click',
    LEAD_MAGNET_COMPLETED: 'Lead Magnet Completed',
    LEAD_MAGNET_FORM_COMPLETED: 'Lead Magnet Form Completed',
    LEAD_MAGNET_EXIT_INTENT: 'Lead Magnet Exit Intent',
    LEAD_MAGNET_EXIT_INTENT_COMPLETED: 'Lead Magnet Exit Intent Completed',
    KNOWLEDGE_READING_PROGRESS: 'Knowledge: Reading Progress',
    NEWSLETTER_SIGNUP: 'Newsletter Signup',

    SHARE: 'Share',

    TRIP_GROUP_DEPARTURES_CTA: 'Trip: Group Departures CTA',
    TRIP_CUSTOM_TRIP_CTA: 'Trip: Custom Trip CTA',
    TRIP_LEAD_MAGNET_CLICK: 'Trip: Lead Magnet Click',
    TRIP_ENQUIRE: 'Trip: Enquire',
    TRIP_ENQUIRY_SENT: 'Trip: Enquiry Sent',
    TRIP_CUSTOM_ENQUIRY_SENT: 'Trip: Custom Enquiry Sent',

    TRIP_ENQUIRY_ABANDONED: 'Trip: Enquiry Abandoned',
    TRIP_CUSTOM_ENQUIRY_ABANDONED: 'Trip: Custom Enquiry Abandoned',
    ITINERARY_CUSTOM_ENQUIRY_ABANDONED: 'Itinerary: Custom Enquiry Abandoned',

    TRIP_ENQUIRY_COMPLETED: 'Trip: Enquiry Completed',
    TRIP_CUSTOM_ENQUIRY_COMPLETED: 'Trip: Custom Enquiry Completed',
    ITINERARY_CUSTOM_ENQUIRY_COMPLETED: 'Itinerary: Custom Enquiry Completed',

    ITINERARY_CUSTOM_TRIP_CTA: 'Itinerary: Custom Trip CTA',
    ITINERARY_GROUP_DEPARTURES_CTA: 'Itinerary: Group Departures CTA',
    ITINERARY_ENQUIRE: 'Itinerary: Enquire',
    ITINERARY_CUSTOM_ENQUIRY_SENT: 'Itinerary: Custom Enquiry Sent',

    CTA_BUTTON_CLICKED: 'CTA Button Clicked',

    CHECKOUT_SUMMARY_VIEWED: 'Checkout Summary Viewed',
    CHECKOUT_BILLING_DETAILS: 'Checkout Billing Details Started',
    CHECKOUT_PAYMENT_STARTED: 'Checkout Payment Started',
    CHECKOUT_PAYMENT_COMPLETED: 'Checkout Payment Completed',
} as const;
export type AnalyticsEventName =
    (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS];

export const leadGenerationEvents: readonly AnalyticsEventName[] = [
    ANALYTICS_EVENTS.CONTACT_FORM_SENT,
    ANALYTICS_EVENTS.TRIP_ENQUIRY_SENT,
    ANALYTICS_EVENTS.TRIP_CUSTOM_ENQUIRY_SENT,
    ANALYTICS_EVENTS.ITINERARY_CUSTOM_ENQUIRY_SENT,
    ANALYTICS_EVENTS.LEAD_MAGNET_COMPLETED,
    ANALYTICS_EVENTS.LEAD_MAGNET_FORM_COMPLETED,
    ANALYTICS_EVENTS.LEAD_MAGNET_EXIT_INTENT_COMPLETED,
    ANALYTICS_EVENTS.NEWSLETTER_SIGNUP,
];
